var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.8148 63.4976C92.8148 87.3688 74.5679 101.411 49.4605 101.411C24.3532 101.411 4 82.3879 4 58.0564C4 33.7248 24.3532 14 49.4605 14C77.5443 15.5795 101.415 16.4573 113 14.7012C113 14.7012 108.787 25.9363 95.6232 28.9195C75.9646 32.9572 62.0982 28.0419 52.7955 28.5684C51.2158 28.6579 49.6361 28.744 48.2319 28.9195C43.6474 29.4925 39.4327 31.1079 35.6082 33.4246C35.5441 33.4442 35.481 33.4637 35.4187 33.4831L35.5242 33.4757C26.7962 38.807 20.8502 49.3865 20.8502 61.5668C20.8502 79.1126 33.1883 93.3365 48.4074 93.3365C63.6265 93.3365 75.9646 79.1126 75.9646 61.5668C75.9646 48.0118 70.71 36.2909 60.343 31.7279C68.5296 32.306 74.7359 33.8341 83.5121 42.2593C88.9533 48.2271 92.2882 53.8438 92.8148 63.4976Z",
    fill: "#BAC9D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigma);
export default __webpack_public_path__ + "static/media/Sigma.eeed2550.svg";
export { ForwardRef as ReactComponent };